import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadReviews () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('reviews_admin', { params })
      .then(result => {
        this.reviews = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  openReviewDetails (review) {
    this.showReviewDetails = true
    this.openReview = review
  },

  closeReviewDetails () {
    this.showReviewDetails = false
    this.openReview = {}
  },

  updateReviewStatus (review, status) {
    const api = getApiClient(this.$store)

    api.patch(review['@id'], { status: status }, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    })
      .then(() => {
        this.loadReviews()
      })
      .catch(error => {
        this.error = error
      })
  },

  updateFeaturedStatus (review, featured) {
    const api = getApiClient(this.$store)

    api.patch(review['@id'], { featured: featured }, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    })
      .then(() => {
        this.loadReviews()
      })
      .catch(error => {
        this.error = error
      })
  },

  clearFilters () {
    this.filters = {}
    this.loadReviews()
  },
}
